import React, { useRef, useState } from 'react'

import { useHistory } from 'react-router-dom'
import { Box, Button, Container, Grid } from '@material-ui/core'

import useFetch from 'hooks/useFetch'
import usePermissions from 'hooks/usePermissions'

import { Page, ContentHeader } from 'components'
import ManageStepper from './components/ManageStepper'
import StepPreviewCourse from './components/steps/StepPreviewCourse'
import StepPreviewCertificate from './components/steps/StepPreviewCertificate'
import StepManagePeople from './components/steps/StepManagePeople'
import StepSettings from './components/steps/StepSettings'

import * as service from 'service'
import useStyles from './styles'
import { routes } from 'Routes'
import permissions from 'constants/permissions'

const LAST_STEP = 3

const STEP_COMPONENTS = [
  StepPreviewCourse,
  StepPreviewCertificate,
  StepManagePeople,
  StepSettings,
]

const TrainingCoursesManage = ({ match }) => {
  const { permitted } = usePermissions()
  const history = useHistory()
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)

  const courseId = match?.params?.courseId
  const isEdit = permitted(permissions.NEW_PLATFORM_COURSE.CONFIG)

  const {
    response: courseCompanyConfigResponse,
    isLoading: isCourseCompanyConfigLoading,
    refresh: refreshCourseCompanyConfig,
  } = useFetch(
    service.dponet.trainingCourse.courseCompanyConfig,
    { courseId },
    [courseId],
  )

  const courseCompanyConfig =
    courseCompanyConfigResponse?.data?.courseCompanyConfig ?? {}

  const ActiveStepComponent = STEP_COMPONENTS[activeStep]

  const stepSettingsFormRef = useRef(null)

  const handleBack = () => {
    if (activeStep === 0) return history.push(routes.trainingCourses.all)
    return setActiveStep((prev) => Math.max(prev - 1, 0))
  }
  const handleNext = () =>
    setActiveStep((prev) => Math.min(prev + 1, LAST_STEP))

  const handleIndex = () => history.push(routes.trainingCourses.all)

  const handlePrimaryAction = () => {
    if (activeStep < LAST_STEP) return handleNext()
    if (activeStep === LAST_STEP && !isEdit) return handleIndex()
    if (stepSettingsFormRef.current) {
      stepSettingsFormRef.current.requestSubmit()
    }
  }

  const title = isEdit ? 'Configurar Curso' : 'Visualizar Curso'
  return (
    <Page title={title}>
      <Container maxWidth={false} className={classes.content}>
        <ContentHeader title={title} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ManageStepper activeStep={activeStep} />
          </Grid>
          <Grid item xs={12}>
            <ActiveStepComponent
              courseId={courseId}
              courseCompanyConfig={courseCompanyConfig}
              isCourseCompanyConfigLoading={isCourseCompanyConfigLoading}
              refreshCourseCompanyConfig={refreshCourseCompanyConfig}
              formRef={stepSettingsFormRef}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.button}>
              <Button variant="outlined" onClick={handleBack}>
                Voltar
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handlePrimaryAction}
              >
                {activeStep < LAST_STEP || !isEdit ? 'Próximo' : 'Salvar'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default TrainingCoursesManage
